export default __webpack_public_path__ + "static/media/product-request-banner-desktop.be42f17f.png";